module.exports = __webpack_public_path__ + "img/plane-right.e2f78abb.svg";